// 对 axios 作配置
// 导入axios 
import axios from 'axios';
// import qs from 'qs'
// import baseurl from './config';

// 使用自定义配置新建一个axios 实例，对axios 做一些基础配置
// console.log(process.env.NODE_ENV, 'env')
const instance = axios.create({
    baseURL: 'https://website.renhegroup.net/index.php/Home/Index', // 请求接口的域名
    // baseURL: process.env.NODE_ENV === 'production' ? baseurl : '/api',
    timeout: 100000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // uid: "r0NqtjDaJs.017pwnsQt092",
    },
});

// 添加请求拦截器
instance.interceptors.request.use(
    request => {
        // console.log(sessionStorage.getItem('codes'))
        if (sessionStorage.getItem('codes')) {
            request.headers.uid=sessionStorage.getItem('codes')
            return request
        } else {
            // getTxt();
        }
    }), error => {
        Promise.reject(error)
    }


//响应拦截器
instance.interceptors.response.use((response) => {
    // console.log(response)
    //1.非200响应
    //2.token过期
    //3.异地登陆
    //4.非对象加密的解密
    return response.data
})
export default instance
